import type { EnrichedProposedAction } from './useProposedActionsPlan';

/**
 * Lists actions awaiting a decision first, except that a pending action whose
 * prerequisite is already decided moves down with it, so a blocked action
 * never appears above the action it is waiting on.
 *
 * `items` must already be dependency-first, as `selectEnrichedActiveActions`
 * returns them; both groups keep that order.
 */
export function orderForDisplay(
  items: readonly EnrichedProposedAction[]
): EnrichedProposedAction[] {
  const awaitingDecision: EnrichedProposedAction[] = [];
  const rest: EnrichedProposedAction[] = [];
  const restIds = new Set<string>();

  for (const item of items) {
    const followsRest = item.action.depends_on_action_external_ids.some((id) => restIds.has(id));
    if (item.action.decision === 'Pending' && !followsRest) {
      awaitingDecision.push(item);
    } else {
      rest.push(item);
      restIds.add(item.action.external_id);
    }
  }

  return [...awaitingDecision, ...rest];
}
